"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const IssueRequiredField_1 = __importStar(require("@opsbase/lib-issue/IssueRequiredField/IssueRequiredField"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.IssueViewFields = {
    [ViewFieldKey_1.default.ISSUE_LASTCOMMENT]: {
        key: ViewFieldKey_1.default.ISSUE_LASTCOMMENT,
        label: () => lib_i18n_1.default.t('issue-lastcomment'),
        description: () => lib_i18n_1.default.t('issue-lastcomment-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.ISSUE_LASTCOMMENT,
        width: 400,
        gqlFields: 'comments, commentors { id, title, profileImageUrl }',
    },
    [ViewFieldKey_1.default.ISSUE_STATUS]: {
        key: ViewFieldKey_1.default.ISSUE_STATUS,
        label: () => lib_i18n_1.default.t('issue-status'),
        description: () => lib_i18n_1.default.t('issue-status-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.ISSUE_STATUS,
        propertyName: 'status',
        width: 100,
        gqlFields: 'status',
    },
    [ViewFieldKey_1.default.ISSUE_FLAG]: {
        key: ViewFieldKey_1.default.ISSUE_FLAG,
        label: () => lib_i18n_1.default.t('issue-priority'),
        description: () => lib_i18n_1.default.t('issue-priority-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.ISSUE_FLAG,
        propertyName: 'flag',
        width: 75,
        gqlFields: 'flag',
    },
    [ViewFieldKey_1.default.ISSUE_TYPE]: {
        key: ViewFieldKey_1.default.ISSUE_TYPE,
        fieldType: StaticFieldType_1.default.ISSUE_TYPE,
        propertyName: 'type',
        label: () => lib_i18n_1.default.t('issue-type'),
        description: () => lib_i18n_1.default.t('issue-type-description'),
        sortable: true,
        width: 150,
        gqlFields: 'type',
    },
    [ViewFieldKey_1.default.ISSUE_OCCURRENCE]: {
        key: ViewFieldKey_1.default.ISSUE_OCCURRENCE,
        label: () => lib_i18n_1.default.t('issue-occurred'),
        description: () => lib_i18n_1.default.t('issue-occurred-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'occurrenceDate',
        width: 150,
        gqlFields: 'place { id, timezone },occurrenceDate',
    },
    [ViewFieldKey_1.default.ISSUE_ASSIGNEDTO]: {
        key: ViewFieldKey_1.default.ISSUE_ASSIGNEDTO,
        label: () => lib_i18n_1.default.t('assignee'),
        description: () => lib_i18n_1.default.t('assignee-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.RELATED_SPT,
        propertyName: 'assignedTo',
        width: 150,
        gqlFields: 'assignedToSPTType,' +
            'assignedToStaff { id, title, hasProfileImage, profileImageUrl },' +
            'assignedToPosition { id, title },' +
            'assignedToTeam { id, title }',
    },
    [ViewFieldKey_1.default.ISSUE_CREATEDBY]: {
        key: ViewFieldKey_1.default.ISSUE_CREATEDBY,
        fieldType: BasicFieldType_1.default.RELATED_USER,
        propertyName: 'createdBy',
        label: () => lib_i18n_1.default.t('reported-by'),
        description: () => lib_i18n_1.default.t('reported-by-description'),
        sortable: false,
        linkPage: lib_pages_1.default.STAFF_EDIT,
        width: 180,
        gqlFields: 'createdBy { id, title, profileImageUrl }',
    },
    [ViewFieldKey_1.default.ISSUE_OP]: {
        key: ViewFieldKey_1.default.ISSUE_OP,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        propertyName: 'op',
        label: () => lib_i18n_1.default.t('issue-op'),
        description: () => lib_i18n_1.default.t('issue-op-description'),
        sortable: false,
        width: 150,
        gqlFields: 'op { id, title }',
    },
    [ViewFieldKey_1.default.ISSUE_ASSET]: {
        key: ViewFieldKey_1.default.ISSUE_ASSET,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        propertyName: 'asset',
        label: () => lib_i18n_1.default.t('issue-asset'),
        description: () => lib_i18n_1.default.t('issue-asset-description'),
        sortable: false,
        width: 150,
        gqlFields: 'asset { id, title }',
    },
    [ViewFieldKey_1.default.ISSUE_DEADLINEDATE]: {
        key: ViewFieldKey_1.default.ISSUE_DEADLINEDATE,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'deadlineDate',
        label: () => lib_i18n_1.default.t('deadline-date'),
        description: () => lib_i18n_1.default.t('deadline-date-description'),
        sortable: true,
        width: 150,
        gqlFields: 'place { id, timezone } ,deadlineDate',
    },
    [ViewFieldKey_1.default.ISSUE_CLOSEDDATE]: {
        key: ViewFieldKey_1.default.ISSUE_CLOSEDDATE,
        label: () => lib_i18n_1.default.t('closed-date'),
        description: () => lib_i18n_1.default.t('closed-date-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'closeDate',
        width: 150,
        gqlFields: 'place { id, timezone } ,status, closedDate, updatedDate',
    },
    [ViewFieldKey_1.default.ISSUE_RESOLUTION_TIME]: {
        key: ViewFieldKey_1.default.ISSUE_RESOLUTION_TIME,
        label: () => lib_i18n_1.default.t('resolution-time'),
        description: () => lib_i18n_1.default.t('resolution-time-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'resolutionTime',
        width: 150,
        gqlFields: 'closedDate, updatedDate, occurrenceDate, status',
    },
    [ViewFieldKey_1.default.ISSUE_DUESTATUS]: {
        key: ViewFieldKey_1.default.ISSUE_DUESTATUS,
        label: () => lib_i18n_1.default.t('issue-due-status'),
        description: () => lib_i18n_1.default.t('issue-due-status-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'dueStatus',
        width: 150,
        gqlFields: 'closedDate, updatedDate, occurrenceDate, status, deadlineDate',
    },
    [ViewFieldKey_1.default.ISSUE_CAUSES]: {
        key: ViewFieldKey_1.default.ISSUE_CAUSES,
        label: () => (0, IssueRequiredField_1.issueRequiredFieldLabel)(IssueRequiredField_1.default.CAUSES),
        sortable: false,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'causes',
        width: 150,
        gqlFields: 'causes',
    },
    [ViewFieldKey_1.default.ISSUE_CORRECTIVEACTIONS]: {
        key: ViewFieldKey_1.default.ISSUE_CORRECTIVEACTIONS,
        label: () => (0, IssueRequiredField_1.issueRequiredFieldLabel)(IssueRequiredField_1.default.CORRECTIVE_ACTIONS),
        sortable: false,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'correctiveActions',
        width: 150,
        gqlFields: 'correctiveActions',
    },
    [ViewFieldKey_1.default.ISSUE_PREVENTATIVEACTIONS]: {
        key: ViewFieldKey_1.default.ISSUE_PREVENTATIVEACTIONS,
        label: () => (0, IssueRequiredField_1.issueRequiredFieldLabel)(IssueRequiredField_1.default.PREVENTATIVE_ACTIONS),
        sortable: false,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'preventativeActions',
        width: 150,
        gqlFields: 'preventativeActions',
    },
    [ViewFieldKey_1.default.ISSUE_CLOSEDBY]: {
        key: ViewFieldKey_1.default.ISSUE_CLOSEDBY,
        fieldType: BasicFieldType_1.default.RELATED_USER,
        propertyName: 'closedBy',
        label: () => lib_i18n_1.default.t('closed-by'),
        description: () => lib_i18n_1.default.t('closed-by-description'),
        sortable: false,
        linkPage: lib_pages_1.default.STAFF_EDIT,
        width: 180,
        gqlFields: 'closedBy { id, title, profileImageUrl }',
    },
};
exports.default = exports.IssueViewFields;
